import React, { useState } from "react";
import { IInvoice } from "../../interfaces/IInvoice";
import { ILinkedInvoice, linkedInvoiceSchema } from "../../interfaces/ILinkedInvoice";
import { Autocomplete, AutocompleteRenderInputParams, Dialog, DialogContent, IconButton, linearProgressClasses, MenuItem, Table, TableBody, TableCell, TableHead, TableRow, TextField, Typography } from "@mui/material";
import { Add } from "@mui/icons-material";
import { InvoiceLinkedRow } from "./InvoiceLinkedRow";


interface IProps {
    invoice: IInvoice;
    invoices: IInvoice[];
    linkedInvoices: ILinkedInvoice[] | null;
    setLinkedInvoices: Function;
}


export const InvoiceLinkedEdit:React.FC<IProps> = ({
    invoice,
    invoices,
    linkedInvoices,
    setLinkedInvoices
}) => {
    
    const [isOpenSelect,setIsOpenSelect] = useState(false);
    const [selectedInves,setSelectedInves] = useState<number[]>([]);
    //
    const liknedInvPaymentProgress = linkedInvoices?.filter(linkedInv => invoices.find(inv => inv.id === linkedInv.ToInvoice)?.InvoiceType === 20)
    const liknedInvCrediting = linkedInvoices?.filter(linkedInv => invoices.find(inv => inv.id === linkedInv.ToInvoice)?.InvoiceType === 50)
    const liknedInvNachtrag = linkedInvoices?.filter(linkedInv => invoices.find(inv => inv.id === linkedInv.ToInvoice)?.InvoiceType === 40)

    const filteredInvoices = invoices.filter(inv =>
        inv.id !== invoice.id
        && [20,40,50].includes(inv.InvoiceType)
    )
    const includedId = (linkedInvoices === null) ? [] : linkedInvoices.map(linked => linked.ToInvoice);


    const handleOpenSelect = () => {
        setSelectedInves([]);
        setIsOpenSelect(true);
    }
    const handleCloseSelect = () => {
        setIsOpenSelect(false);
    }


    return(
        <>
            {(isOpenSelect) &&
                <Dialog
                    open
                    onClose={handleCloseSelect}
                >
                    <DialogContent>
                    </DialogContent>
                </Dialog>
            }



            <Typography 
                variant="h6"
                sx={{
                    mt: 5,
                    mb: 2
                }}
            >
                Zugeordnete Rechnungen
            </Typography>

            <Autocomplete
                multiple
                fullWidth
                options={filteredInvoices}
                getOptionLabel={(inv: IInvoice) => {
                    return `${inv.invoice_number} ${inv.title}`;
                }}
                value={filteredInvoices.filter((inv) => includedId.includes(inv.id))}
                onChange={(_, newValue) => {
                    setLinkedInvoices([
                        ...newValue.map(inv =>{
                            return linkedInvoiceSchema.parse({
                                FromInvoice: invoice.id,
                                ToInvoice: inv.id,
                                positionTitle: (inv.InvoiceType === 10) ? "Materialanteil (werden summiert)" : `${inv.title} ${inv.invoice_number}`
                            })
                        })
                    ]);
                }}
                renderInput={(params: AutocompleteRenderInputParams) =>
                    React.createElement(TextField, {
                        ...(params as any),
                        label: "Zugeordnete Rechnungen",
                        variant: "outlined",
                    })
                }
                size="small"
            />

            <Table size="small">
                <TableHead>
                    <TableRow>
                        <TableCell>RG-Nummer</TableCell>
                        <TableCell>Positionstitel</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    <TableRow>
                        <TableCell colSpan={2}>
                            <Typography sx={{fontWeight: "bold"}}> 
                                Abschlagsrechnungen
                            </Typography>
                        </TableCell>
                    </TableRow>
                    {(liknedInvPaymentProgress === undefined || liknedInvPaymentProgress.length === 0) ?
                            <TableRow>
                                <TableCell 
                                    colSpan={4}
                                >
                                    <i>Keine zugeordnete Abschlagsrechnungen vorhanden.</i>
                                </TableCell>
                            </TableRow>
                            :  (liknedInvPaymentProgress !== undefined)  && liknedInvPaymentProgress!.map(linkedInv =>
                                <InvoiceLinkedRow    
                                    key={`linkedElement-${linkedInv.ToInvoice}`}
                                    invoices={invoices}
                                    linkedInv={linkedInv}
                                    linkedInvoices={linkedInvoices || []}
                                    setLinkedInvoices={setLinkedInvoices}
                                />

                            )
                    }


                    <TableRow>
                        <TableCell colSpan={2}>
                            <Typography sx={{fontWeight: "bold"}}> 
                                Gutschriften
                            </Typography>
                        </TableCell>
                    </TableRow>
                    {(liknedInvCrediting === undefined || liknedInvCrediting.length === 0) ?
                            <TableRow>
                                <TableCell 
                                    colSpan={4}
                                >
                                    <i>Keine zugeordnete Gutschriften vorhanden.</i>
                                </TableCell>
                            </TableRow>
                            :  (liknedInvCrediting !== undefined)  && liknedInvCrediting!.map(linkedInv =>
                                <InvoiceLinkedRow    
                                    key={`linkedElement-${linkedInv.ToInvoice}`}
                                    invoices={invoices}
                                    linkedInv={linkedInv}
                                    linkedInvoices={linkedInvoices || []}
                                    setLinkedInvoices={setLinkedInvoices}
                                />

                            )
                    }


                    <TableRow>
                        <TableCell colSpan={2}>
                            <Typography sx={{fontWeight: "bold"}}> 
                                Nachtragsrechnungen
                            </Typography>
                        </TableCell>
                    </TableRow>
                    {(liknedInvNachtrag === undefined || liknedInvNachtrag.length === 0) ?
                            <TableRow>
                                <TableCell 
                                    colSpan={4}
                                >
                                    <i>Keine zugeordnete Nachtragsrechnungen vorhanden.</i>
                                </TableCell>
                            </TableRow>
                            :  (liknedInvNachtrag !== undefined)  && liknedInvNachtrag!.map(linkedInv =>
                                <InvoiceLinkedRow    
                                    key={`linkedElement-${linkedInv.ToInvoice}`}
                                    invoices={invoices}
                                    linkedInv={linkedInv}
                                    linkedInvoices={linkedInvoices || []}
                                    setLinkedInvoices={setLinkedInvoices}
                                />

                            )
                    }
                </TableBody>
            </Table>

        </>
    )
}